module.exports = __webpack_public_path__ + "img/lsjn5.d34b8fe7.jpg";